"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const englishTranslation = {
    asideOrderSummaryTitle: 'Order Summary',
    asidePromoAddLink: 'add promo code',
    asidePromoAppliedLabel: 'applied promo codes',
    asidePromoRemove: 'remove promotion code',
    asidePromoInputLabel: 'Add a promotional code',
    asidePromoCancel: 'cancel',
    asidePromoApply: 'Apply',
    asideSubtotal: 'Subtotal',
    asideShipping: 'Shipping',
    asideShippingQuestionsLink: 'Questions on free shipping?',
    asideShippingQuestionsText: 'Products within Books, Bibles, Vacation Bible School (some exclusions apply) and church supplies categories qualify for free shipping with a minimum order of $50.',
    asideShippingQuestionsNote: 'Note',
    asideShippingQuestionsNoteText: 'If products outside of these categories are included in your order, shipping charges will apply for those products.',
    asideShippingQuestionsExclusionsLink: 'see further details and exclusions',
    asideGiftCards: 'Gift Cards',
    asideCalculated: 'calculated at checkout',
    asideTax: 'Tax',
    asidePromo: 'Promo',
    asideTotal: 'Total',
    checkoutButtonText: 'Secure checkout',
    asideQuickAddLabel: 'Add item to cart by product id',
    asideQuickAddButtonText: 'Add',
    asideQuickAddErrorText: 'Item could not be found. Please check the item number and try again.',
    asidePlaceOrderButtonText: 'Place Order',
    asidePlaceOrderNoteText: 'By clicking "Place Order" you are confirming that you agree to our',
    asidePlaceOrderNoteTermsLink: 'Terms and Conditions',
    asidePlaceOrderNoteAnd: 'and',
    asidePlaceOrderNotePolicyLink: 'Privacy Policy',
};
exports.default = englishTranslation;
